export default class CRender {

    constructor(canvas) {
        this._canvas = canvas;
        this._context = canvas.getContext('2d');
        this._canvas.width = canvas.parentNode.clientWidth;
        this._setRatio();
    }

    _setRatio() {
        let devicePixelRatio = window.devicePixelRatio || 1,
            backingStoreRatio = this._context.webkitBackingStorePixelRatio ||
                this._context.mozBackingStorePixelRatio ||
                this._context.msBackingStorePixelRatio ||
                this._context.oBackingStorePixelRatio ||
                this._context.backingStorePixelRatio || 1,

            ratio = devicePixelRatio / backingStoreRatio;

        this._width=this._canvas.width;
        this.height=this._canvas.height;
        if (devicePixelRatio !== backingStoreRatio) {

            let oldWidth = this._canvas.width;
            let oldHeight = this._canvas.height;

            this._canvas.width = oldWidth * ratio;
            this._canvas.height = oldHeight * ratio;

            this._canvas.style.width = oldWidth + 'px';
            this._canvas.style.height = oldHeight + 'px';

            this._width=oldWidth;
            this._height=oldHeight;
            this._context.setTransform(ratio, 0, 0, ratio, 0, 0);

        }
    }

    clear() {
        let me = this;
        me._context.clearRect(0, 0, me._canvas.width, me._canvas.height);
    }

    update(elements) {
        let me = this;
        me.clear();
        let labelWidth = this.measureLabelWidth(elements, me._context) + 5;
        elements.forEach(function (item) {
            item.update(me._context, labelWidth);
        });
    }

    getWidth() {
        return this._width ;
    }

    getHeight() {
        return this._height;
    }

    measureLabelWidth(elements, canvas) {
        let maxLabelWidth = 0;
        elements.forEach(elem => {
            if (typeof elem.getLabel !== 'function') {
                return;
            }

            let labelWidth = canvas.measureText(elem.getLabel()).width;

            if (labelWidth > maxLabelWidth) {
                maxLabelWidth = labelWidth;
            }
        });

        return maxLabelWidth;
    }
}


// WEBPACK FOOTER //
// ./src/components/cchart/CRender.js